import ReactDOM from "react-dom";
import { result } from "lodash";
import React, {
  useRef,
  useState,
  useEffect,
  useCallback,
  useContext,
} from "react";

import {
  useInfiniteQuery,
  QueryClient,
  QueryClientProvider,
} from "react-query";
import { get, post } from "../http/http";
import SpinnerLoading from "../Spinner/SpinnerLoading";
import ScrollManager from "../ScrollManager/ScrollManager";
import ErrorLoadData from "../Error/ErrorLoadData";
import Header from "../Header/Header";
import ColorItem from "./ColorItem";
import { Context } from "../Context/Context";


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      keepPreviousData: true,
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  },
});

export default function Colors() {
  const {searchColor , setSearchColor}=useContext(Context)

  return (
    <>
        <QueryClientProvider client={queryClient}>
          <ScrollManager scrollKey="colors_index" />
          <div className="list_parent">
            <Header
              setSearch={setSearchColor}
              searchValue={searchColor}
              title={"لیست رنگ ها"}
              placeholderInputSearch={"جستجوی رنگ با نام رنگ"}
              urlCreateBtn={"/colors/create"}
              txtCreateBtn={"افزودن رنگ"}
            />
            <div className="list">
              <Records/>
            </div>
          </div>
        </QueryClientProvider>
    </>
  );
}

///////////////

const Records = () => {
  const { lastIdColor , searchColor } = useContext(Context);
  function handleRefresh() {
    queryClient.resetQueries("colors_repoData");
  }
  const request = { name: searchColor, last_id: lastIdColor.current };
  const {
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    data,
    status,
    error,
    isError,
  } = useInfiniteQuery(
    ["colors_repoData", searchColor],
    ({ pageParam = 1, signal }) =>
      post(`/api/admin/colors/index?page=${pageParam}`, request, {
        signal: signal,
      }),
    {
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage && lastPage.length > 0) {
          lastIdColor.current = lastPage[lastPage.length - 1].id;
        }
        return lastPage.length ? allPages.length + 1 : undefined;
      },
    }
  );

  const intObserver = useRef();
  const lastPostRef = useCallback(
    (post) => {
      if (isFetchingNextPage) return;
      if (intObserver.current) intObserver.current.disconnect();
      intObserver.current = new IntersectionObserver((posts) => {
        if (posts[0].isIntersecting && hasNextPage) {
          console.log("We are near the last post!");
          fetchNextPage();
        }
      });

      if (post) intObserver.current.observe(post);
    },
    [isFetchingNextPage, fetchNextPage, hasNextPage]
  );

  const content = data?.pages.map((pg) => {
    return pg.map((item, index) => {
      if (pg.length === index + 1) {
        return (
          <ColorItem
            ref={lastPostRef}
            key={item.id}
            index={index}
            item={item}
            name={searchColor}
            queryClient={queryClient}
          />
        );
      }
      return (
        <ColorItem
          key={item.id}
          index={index}
          item={item}
          name={searchColor}
          queryClient={queryClient}
        />
      );
    });
  });

  return (
    <div>
      {content}

      {isLoading && <SpinnerLoading />}
      {isFetchingNextPage &&
        data.pages[data.pages.length - 1].length >= 100 && <SpinnerLoading />}

      {isFetching && !isFetchingNextPage && <SpinnerLoading />}

      {isLoading == false && data && Object.keys(data.pages[0]).length < 1 && (
        <div className="empty_container">
          <div className="inner">
            <p className="empty">متأسفانه موردی پیدا نشد !</p>
          </div>
        </div>
      )}
      {isError && <ErrorLoadData func={handleRefresh} />}
    </div>
  );
};

export function useQueryClientColors() {
  return [queryClient];
}
